module.exports = __webpack_public_path__ + "img/09d.b8f78463.png";